import { PdRadioGroup } from "./pd-radio-group/PdRadioGroup.js";
//#region src/pd-radio-group/pd-radio-group.ts
var tag = "pd-radio-group";
if (!customElements.get(tag)) customElements.define(tag, PdRadioGroup);
//#endregion
export { PdRadioGroup };
